import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { BankAccountTransaction } from 'app/models/dto/bank-account.model';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import _ from 'lodash';



@Component({
  selector: 'app-alternate-transactions',
  templateUrl: './alternate-transactions.component.html',
  styleUrls: ['./alternate-transactions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlternateTransactionsComponent implements OnInit {

  displayedColumns: string[] = ['postedDate', 'description', 'amount'];
  dataSource: MatTableDataSource<any>;


  constructor(@Inject(MAT_DIALOG_DATA) public data: BankAccountTransaction[]) { }

  ngOnInit(): void {
    const data =  _.orderBy(this.data, ['postedDate'], ['desc']);
    this.dataSource = new MatTableDataSource(data);

  }

}
